import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from './actions';
import { ListOption } from './listOption';
import _ from 'lodash';

let Sort = class Sort extends ListOption {
  constructor(props) {
    super(props);
    var values = (this._values = [
      props.searchQuery ? 'Relevance' : 'Staff Select',
      'A to Z',
      'Price: Low to High',
      'Price: High to Low'
    ]);
    this.map = {};
    this.map[values[0]] = { sort: 'featured', order: 'asc' };
    this.map[values[1]] = { sort: 'title', order: 'asc' };
    this.map[values[2]] = { sort: 'price', order: 'asc' };
    this.map[values[3]] = { sort: 'price', order: 'desc' };
  }

  render() {
    if (
      !this.props.products ||
      !this.props.products[0] ||
      !_.some(this.props.products, 'price')
    ) {
      this.values = this._values.slice(0, 2);
    } else {
      this.values = this._values;
    }
    return (
      <ul className="filter-option-list">
        {this.values.map(value => (
          <li
            className={
              'filter-option-item' + (this.isSelected(value) ? ' selected' : '')
            }
            key={value}
            onClick={this.toggle.bind(this, value)}
          >
            <i className="filter-option-item-toggle" />
            <span className="filter-option-item-value">{value}</span>
          </li>
        ))}
      </ul>
    );
  }

  isSelected(value) {
    return (
      this.map[value].sort == this.props.selected.sort &&
      this.map[value].order == this.props.selected.order
    );
  }

  toggle(value) {
    let map = this.map[value];
    let selected = { ...this.props.selected, sort: map.sort, order: map.order };
    this.props.selectFilters(selected);
    this.props.history.replace(
      actions.pathForSelected(this.props.location, selected)
    );
  }
};

function mapStateToProps(state) {
  return { ...state.filter, searchQuery: state.category.searchQuery };
}

Sort = withRouter(Sort);
export default connect(mapStateToProps, { ...actions })(Sort);



// WEBPACK FOOTER //
// ./shared/components/filter/sort.js